import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

export default function CategoryNav() {
  return (
    <section className="w-full bg-background-50">
      <div className="w-full max-w-7xl mx-auto px-4 md:px-6 py-10 md:py-14">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-900 mb-2">
            探索内容分类
          </h2>
          <p className="text-foreground-500 text-sm">
            八大内容领域，总有你感兴趣的精彩世界
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center p-5 md:p-6 rounded-xl bg-background-100 hover:bg-accent-100/50 border border-background-200/60 hover:border-accent-300 transition-all duration-300"
            >
              <div className={`w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-xl ${cat.color} mb-3 md:mb-4 group-hover:scale-110 transition-transform duration-300`}>
                <i className={`${cat.icon} text-xl md:text-2xl`}></i>
              </div>
              <h3 className="font-heading text-sm md:text-base font-bold text-foreground-800 mb-1">
                {cat.name}
              </h3>
              <p className="text-foreground-500 text-xs text-center leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <span className="text-foreground-400 text-xs mt-2">
                {cat.videoCount} 部视频
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}